<template>
    <div>
      <b-container fluid>
        <b-row>
          <b-col>
            <b-row align-v="center" align-h="end">
              <b-col>
              </b-col>
  
              <b-col></b-col>
  
              <b-col align="right">
                <b-button v-b-tooltip.hover title="Crear calculo Atrato" v-if="$localStorageService.can('Config_atrato_nuevo')" variant="outline-success"
                          @click="agregar()"
                >Crear calculo Atrato
                </b-button>
              </b-col>
  
            </b-row>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="12">
            <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosTabla"
                :fields="fields"
                :per-page="registrosPorPagina"
                :current-page="paginaActual"
                responsive="true"
                class="parrafos"
                fixed>
                <template v-slot:cell(plazoQuincena)="row">
                    <span>{{ row.item.plazoQuincena }}</span>
                </template>
                <template v-slot:cell(montoMinimo)="row">
                    <span>{{ row.item.montoMinimo | moneda }}</span>
                </template>
                <template v-slot:cell(tasaNetaAnualidad)="row">
                    <span>{{ row.item.tasaNetaAnualidad }}%</span>
                </template>
                <template v-slot:cell(impuesto)="row">
                    <span>{{ row.item.impuesto }}%</span>
                </template>
                <template v-slot:cell(Acciones)="row">
                    <b-button-group>
                    <b-button
                        title="Modificar calculo Atrato"
                        size="sm"
                        variant="outline-warning"
                        @click="modificar(row.item)"
                        v-if="$localStorageService.can('Config_atrato_Detalle')"
                    ><em class="fa fa-pencil"></em></b-button>
                    <b-button
                        v-if="!row.item.registroActivo && $localStorageService.can('Config_atrato_activar')"
                        title="Activar calculo Atrato"
                        variant="outline-success"
                        size="sm"
                        @click="activarDesactivar(row.item)"
                    ><em class="fa fa-undo"></em></b-button>
                    <b-button v-if="row.item.registroActivo && $localStorageService.can('Config_atrato_activar')"
                                title="Desactivar calculo Atrato"
                                variant="outline-danger"
                                size="sm"
                                @click="activarDesactivar(row.item)"
                    >
                        <b-icon icon="trash-fill"></b-icon>
                    </b-button>
                    </b-button-group>
                </template>
            </b-table>
            <div align="center" v-if="loader">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-col v-if="!loader">
              <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
            </b-col>
            <b-col v-if="!loader">
              <b-pagination
                  v-if="datosTabla !== undefined && datosTabla.length > 10"
                  align="center"
                  v-model="paginaActual"
                  :total-rows="datosTabla.length"
                  :per-page="registrosPorPagina"
                  aria-controls="my-table1"
              ></b-pagination>
            </b-col>
          </b-col>
        </b-row>
  
        <b-modal
            v-model="show"
            :title="tituloModal"
            size="lg"
        >
          <b-container fluid>
            <b-row>
              <b-col>
                <b-form>
                  <b-form-group align="left">
                    <label>Plazo quincenal
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-input-group-prepend is-text>
                        <b-icon icon="menu-button-wide"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input id="plazo" name="plazo" placeholder="Plazo quincenal"
                                    v-model="$v.atrato.plazoQuincena.$model"
                                    type="number" min="1"
                                    oninput="validity.valid||(value='');" onpaste="return false;"
                                    :state="validateState('plazoQuincena')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group align="left">
                    <label>Monto minimo
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-input-group-prepend is-text>
                        <b-icon icon="menu-button-wide"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input id="monto" name="monto" placeholder="Monto minimo"
                                    v-model="$v.atrato.montoMinimo.$model"
                                    type="number" min="0"
                                    oninput="validity.valid||(value='');" onpaste="return false;"
                                    :state="validateState('montoMinimo')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group align="left">
                    <label>Tasa neta anualizada
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-input-group-prepend is-text>
                        <b-icon icon="menu-button-wide"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input id="tasa" name="tasa" placeholder="Tasa neta anualizada"
                                    v-model="$v.atrato.tasaNetaAnualidad.$model"
                                    type="number" min="1"
                                    
                                    :state="validateState('tasaNetaAnualidad')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group align="left">
                    <label>Impuesto
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-input-group-prepend is-text>
                        <b-icon icon="menu-button-wide"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input id="impuesto" name="impuesto" placeholder="Impuesto"
                                    v-model="$v.atrato.impuesto.$model"
                                    type="number" min="1"
                                    oninput="validity.valid||(value='');" onpaste="return false;"
                                    :state="validateState('impuesto')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-form>
              </b-col>
            </b-row>
          </b-container>
          <div slot="modal-footer">
            <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
              <span v-if="!loaderAcciones">Guardar</span>
              <span v-if="loaderAcciones">
                          <b-spinner small></b-spinner>
                      Cargando...
                      </span>
            </b-button>
            <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
          </div>
        </b-modal>
  
      </b-container>
    </div>
  </template>
  
  <script>
  
  import {required} from "vuelidate/lib/validators";
  export default {
    name: "Atrato",
    data: () => ({
      datosTabla: [],
      fields: [
        { key: "idAtrato", label: "ID", sortable: true },
        { key: "plazoQuincena", label: "Plazo quincena", sortable: true },
        { key: "montoMinimo", label: "Monto minimo", sortable: true },
        { key: "tasaNetaAnualidad", label: "Tasa neta anualidad", sortable: true },
        { key: "impuesto", label: "Impuesto", sortable: true },
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      loader: false,
      tituloModal: '',
      loaderAcciones: false,
      show: false,
      atrato: {
        idAtrato: null,
        plazoQuincena: null,
        montoMinimo: null,
        tasaNetaAnualidad: null,
        impuesto: null,
        registro: null,
      },
    }),
    validations: {
      atrato: {
        plazoQuincena: {required},
        montoMinimo: {required},
        tasaNetaAnualidad: {required},
        impuesto: {required},
      }
    },
    created() {
      this.obtenerAtrato();
    },
    methods: {
      obtenerAtrato() {
        this.loader = true;
        this.$http.post(this.$api + "atrato/obtener").then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data;
          }
        }).finally(() => {
          this.loader = false;
        });
      },
      agregar() {
        this.atrato = {
            idAtrato: null,
            plazoQuincena: null,
            montoMinimo: null,
            tasaNetaAnualidad: null,
            impuesto: null,
            registro: null,
        };
        this.tituloModal = 'Agregar Atrato';
        this.show = true;
      },
      guardar(){
        this.$v.atrato.$touch();
        if (this.$v.atrato.$anyError) {
          return;
        }
  
        if (!this.$v.atrato.$invalid) {
          this.loaderAcciones = true;
          this.$http.post(this.$api + 'atrato/guardar', this.atrato).then(respuesta => {
                if (respuesta.data.data) {
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El calculo Atrato se registró correctamente",
                  });
                  this.obtenerAtrato();
                  this.show = false;
                }
              }
          ).catch(error => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Error al guardar el calculo Atrato.",
            });
          }).finally(() => {
                this.loaderAcciones = false;
              }
          )
        }
  
      },
      modificar(item){
        this.atrato = item;
        this.tituloModal = "Modificar calculo Atrato";
        this.show = true;
      },
      activarDesactivar(item){
        const mensaje = item.registroActivo ? '¿Está seguro de desactivar el calculo Atrato?' : '¿Está seguro de activar el calculo Atrato?';
        this.$swal({
          icon: "warning",
          text: mensaje,
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          showCancelButton: true,
          showConfirmButton: true,
        }).then((aceptar) => {
          if (aceptar.value) {
            const parametros = {
              idAtrato: item.idAtrato,
            }
            this.$http.post(this.$api + 'atrato/desactivarActivar/',  parametros).then(respuesta => {
                  if (respuesta.data.data) {
                    item.registroActivo = !item.registroActivo;
                    this.$swal.fire({
                      icon: "info",
                      title: "Aviso",
                      text: "El calculo Atrato se actualizó correctamente",
                    });
                  }
                }
            )
          }
        })
      },
      cerrarModal() {
        this.show = false;
      },
      validateState(name) {
        const {$dirty, $error} = this.$v.atrato[name];
        return $dirty ? !$error : null;
      },
      selectClass(attribute) {
        let state = this.validateState(attribute)
        if (state) {
          return 'border rounded-lg border-success'
        } else if (state === false) {
          return 'border rounded-lg border-danger'
        } else {
          return ''
        }
      }
    }
  
  }
  </script>
  
  <style scoped>
  
  </style>
  